import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import { api } from '../utils/Api'

export default class PaymentTypePicker extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedOption: '',
            isClearable: true,
            isSearchable: true,
            options: [],
            value: {}
        }
    }

    getData = async () => {
        const url = api + '/paymenttype'
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}

        try {
            const { data } = await axios.get(url)
            this.setState({
                options: data
            })

            if(this.props.defaultValue){
                const selectValue = data.filter( type => type.name === this.props.defaultValue)
                if(selectValue.length > 0){
                    this.setState({
                        value: { value: selectValue[0]._id, label: selectValue[0].name }
                    })
                }
            }
        } catch (err) {
            console.error(err.message)
            return null
        }
    }

    componentDidMount() {
        this.getData()
    }

    render() {
        const options = this.state.options.map((item) => {
            return {
                value: item._id,
                label: item.name
            }
        })

        return (
            <div>
                <Select
                    name="form-field-name"
                    placeholder='Payment type...'
                    value={ this.props.defaultValue ? this.state.value : undefined}
                    onChange={this.props.action}
                    isClearable={this.state.isClearable}
                    isSearchable={this.state.isSearchable}
                    options={options}
                    isDisabled={!(localStorage.getItem('role') === 'Finance')}
                    // isDisabled={true}
                />
            </div>
        )
    } 
}
